import React, { useState } from 'react';
import TableCrud from '../../components/TableCrud';

import { Spreadsheet, createEmptyMatrix } from 'react-spreadsheet';
import { useEffect } from 'react';
import { FaTrashAlt } from 'react-icons/fa';
import { IoMdOptions } from 'react-icons/io';
import { Si } from 'react-icons/si';
import Api, { exceptionNotificationAPI } from '../../services/api';
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import { Container, ContainerHeader } from './styles';
import Button from '../../components/Button';
import { success_message, info_message, error_message } from '../../components/Toast/index';
import TableLoading from '../../components/TableLoading';
import { NumericFormat } from 'react-number-format';
import Swal from 'sweetalert2';

import optionsLogo from '../../assets/icons/options.svg';
import { formSelectStyles, formSelectControlFullWidth } from '../../components/FormInput/formSelectStyles';




const MailNotificationDeadlineFormIndex = () => {
    const columns = ["Supplier", "Deadline", "Notify how many days before?", "Start sending?", "CC in 1st communication", " "]

    //Crop Year Select Variables
    const [cropYears, setCropYears] = useState([]);
    const [selectedCropID, setSelectedCropID] = useState(null);
    const [operations, setOperations] = useState([]);
    const [rowLabels, setRowLabels] = useState([]);
    const [selectedOperationID, setSelectedOperationID] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [dataSheet, setDataSheet] = useState([
        [],
        [],
    ]);

    const removeRow = (id) => {
        Swal.fire({
            title: 'Are you sure, you want delete the register?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'No',
            confirmButtonColor: '#102A63',
            cancelButtonColor: '#B0B0BB',
            confirmButtonText: 'Yes'
        }).then((result) => {
            if (result.isConfirmed) {
                Api.post(`MailNotificationDeadlines/delete?id=${id}`).then((result) => {
                    if (selectedCropID && selectedOperationID) {
                        loadDataByCropYearOperation()
                    }
                })
            }
        })
    }

    const InputNumberEdit = ({ cell, onChange }) => {
        console.log(cell.className)
        var rowID = cell.className.split("-");
        console.log(rowID[1])

        return (
            <div style={{ padding: '0.5rem 1rem', textAlign: "center" }} onClick={() => {removeRow(rowID[1])}}>
                <FaTrashAlt />
            </div>
        );
    };

    const InputOptions = ({ cell, onChange }) => {

        return (
            <div style={{ padding: '0.5rem 1rem' }}>
                <img src={optionsLogo} alt="" />
            </div>
        );
    };


    useEffect(() => {
        var userObjectAux = JSON.parse(localStorage.getItem('@Thrive:user'));
        setIsLoading(true)
        loadCropYears(userObjectAux);
        //loadOperations()
    }, [])


    useEffect(() => {
        if (selectedCropID) {
            setIsLoading(true)
            loadOperations()
        }
        
    }, [selectedCropID])


    useEffect(() => {
        if (selectedCropID && selectedOperationID) {
            setIsLoading(true);
            loadDataByCropYearOperation()
        }
    }, [selectedCropID, selectedOperationID])

    const loadCropYears = (userObjectAux) => {
        Api.get(`thriveValue/getAllCropsYears?selectedCulture=${userObjectAux.selectedCultureID}`).then((result) => {
            if (result && result.data) {
                setCropYears(result.data.response);
                setSelectedCropID(result.data.response[0].cropID);
                setIsLoading(false)
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const onChangeCropID = (value) => {
        setSelectedCropID(value);
    }

    const loadOperations = () => {
        Api.get(`Dashboard/getAllOperationsByYear?reportYearID=${selectedCropID}`).then((result) => {
            if (result && result.data) {
                console.log(result.data.response[0].operationID);
                setOperations(result.data.response);

                setSelectedOperationID(result.data.response[0].operationID);
                setIsLoading(false)
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const onChangeOperationID = (value) => {
        setSelectedOperationID(value);
    }

    const loadDataByCropYearOperation = () => {
        if (selectedCropID && selectedOperationID) {
            Api.get(`MailNotificationDeadlines/getAllByReportYearAndCountry?reportYearID=${selectedCropID}&operationID=${selectedOperationID}`).then((result) => {
                if (result && result.data) {
                    var resultList = result.data.response;
                    var newLine = [
                        { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" },  { value: "" },
                    ]
                    resultList.push(newLine)
                    setIsLoading(false)

                    try {
                        resultList.map((row) => {
                            var newRow = row.map((col) => {
                                var newCol = { ...col };
                                return newCol;
                            })
                            return newRow;
                        })

                        try {
                            var rowLabel = [];
                            resultList.map((row) => {
                                var id = row[0].value

                                row[0] = { value: row[1].value }
                                row[1] = { value: row[2].value }
                                row[2] = { value: row[3].value }

                                row[3] = { value: row[4].value }
                                row[4] = { value: row[5].value }                   
                                row[5] = { readOnly: false, className: 'remove-' + id, onClick: () => removeRow(id) };
                                row[5].DataViewer = InputOptions;
                                row[5].DataEditor = InputNumberEdit;


                                rowLabel.push(id);

                                // console.log(rowLabels)
                            })
                            setRowLabels(rowLabel);
                        } catch { }


                        setDataSheet(resultList);
                    } catch (e) {
                        console.log(e)
                    }

                }
            }).catch((error) => {
                exceptionNotificationAPI(error);
            });
        }

    }

    const save = () => {
       
        var obj = {
            reportYearID: selectedCropID,
            operationID: selectedOperationID,
            IDs: rowLabels,
            data: dataSheet
        }
        setIsLoading(true);
        //console.log(objAdditionalData)

        Api.post(`MailNotificationDeadlines/new`, obj).then((result) => {
            if (result && result.data) {
                if (selectedCropID && selectedOperationID) {
                    loadDataByCropYearOperation()
                }
                setIsLoading(false);
                if (result.data.response == true) {
                    success_message("The data was saved!");
                }
                else {
                    info_message("No data to saved!");
                }
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    const onChangeTable = (e) => {
        try {
            setDataSheet(e);
        } catch { }
    }

    const onBlurTable = () => {
        try {
            var nesw = dataSheet.map((row) => {
                var newRow = row.map((col) => {
                    var newCol = { ...col };
                    return newCol;
                })
                return newRow;
            })

            try {
                nesw.map((row, i) => {
                    var value1 = row[1].value != "" ? row[1].value : ""
                    var value2 = row[2].value != "" ? row[2].value : ""
                    var value3 = row[3].value != "" ? row[3].value : ""
                    var value4 = row[4].value != "" ? row[4].value : ""


                    row[0] = { value: row[0].value }
                    row[1] = { value: value1.includes(" - ") || value1 == " " || value1 == "-" || value1 == null || value1 == undefined ? "" : value1 };
                    row[2] = { value: value2.includes(" - ") || value2 == " " || value2 == "-" || value2 == null || value2 == undefined ? "" : value2 };
                    row[3] = { value: value3.includes(" - ") || value3 == " " || value3 == "-" || value3 == null || value3 == undefined ? "" : value3 };
                    row[4] = { value: value4.includes(" - ") || value4 == " " || value4 == "-" || value4 == null || value4 == undefined ? "" : value4 };

                    row[5] = { readOnly: false, className: 'remove-' + row[0].value, onClick: () => {removeRow(row[0].value) }};
                    row[5].DataViewer = InputOptions;
                    row[5].DataEditor = InputNumberEdit;


                })

            } catch { }
            setDataSheet(nesw);
        } catch (e) {
            console.log(e)
        }
    }



    return (
        <Container className="container">
            <ContainerHeader style={{ margin: '2rem 0' }}>
                <h3>Email Notifications - Deadlines Form</h3>
                <div>
                    <Button style={{ marginRight: '15px' }} onClick={() => save()}>Save</Button>
                </div>
            </ContainerHeader>
            <div className="row mt-2">
                <div className="col-md-6 mt-2 mx-4" style={{ width: '100%' }}>
                    <label className='label'>Select Reporting Year:</label>
                    <div className="col-md-6 mt-2" style={{ width: '100%' }}>
                        <Select
                            options={cropYears?.map((y) => ({ value: y.reportYearID, label: y.year })) ?? []}
                            value={cropYears?.find((y) => y.reportYearID === selectedCropID) ? { value: selectedCropID, label: cropYears.find((y) => y.reportYearID === selectedCropID).year } : null}
                            onChange={(x) => onChangeCropID(x?.value ?? '')}
                            placeholder="Select Reporting Year"
                            isSearchable
                            isClearable={false}
                            styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                            classNamePrefix="mailnotification-crop"
                        />
                    </div>
                </div>
                <div className="col-md-6 mt-2 mx-4" style={{ width: '100%' }}>
                    <label className='label'>Select Operation:</label>
                    <div className="col-md-6 mt-2" style={{ width: '100%' }}>
                        <Select
                            options={operations?.map((o) => ({ value: o.operationID, label: o.description })) ?? []}
                            value={operations?.find((o) => o.operationID === selectedOperationID) ? { value: selectedOperationID, label: operations.find((o) => o.operationID === selectedOperationID).description } : null}
                            onChange={(x) => onChangeOperationID(x?.value ?? '')}
                            placeholder="Select Operation"
                            isSearchable
                            isClearable={false}
                            styles={{ ...formSelectStyles, control: formSelectControlFullWidth }}
                            classNamePrefix="mailnotification-operation"
                        />
                    </div>
                </div>
            </div>
            {!isLoading ?
                <Spreadsheet data={dataSheet} rowLabels={rowLabels} columnLabels={columns} onBlur={() => onBlurTable()} onChange={(e) => onChangeTable(e)} />
                :
                <TableLoading />
            }
        </Container>
    )
}

export default MailNotificationDeadlineFormIndex;

